import CryptoJS from "crypto-js";
import config from "../config/config";
import { toastError, toastSuccess } from "./Toast";
import { uploadAWS } from "./AWSHelper";
import { AWS_IMAGE_FOLDER_SALES } from "./Constant";
import axios from "axios";
import * as XLSX from "xlsx";
import { checkUserPermission } from "./UserPermission";
import { useEffect, useState } from "react";

export const setInToStorage = (data) => {
  Object.keys(data).forEach((item) => {
    localStorage.setItem(item, data[item]);
  });
};

export const getFromStorage = (key) => {
  return localStorage.getItem(key);
};

//encrypt by crypto
export function generateFinalKey(customerid) {
  const obj = { ID: customerid, status: "ok" };
  const encryptedData = CryptoJS.AES.encrypt(
    JSON.stringify(obj),
    config?.portalSendIdKey
  ).toString();

  console.log(encryptedData, "090502024 enc");

  const finalKey = encryptedData;
  // .replace(/\+/g, 'aaaa')
  // .replace(/\//g, 'bbbb')
  // .replace(/=/g, 'wwww');

  console.log(finalKey, "090502024 enc rep");
  return finalKey;
}

//decrypt by crypto
export function decryptAndExtractId(cValue) {
  console.log(cValue, "8754");

  if (cValue === null) {
    window.location.href = "/404";
    return null;
  }

  console.log(cValue, "090502024 dec 1");
  const originalKey = cValue.replace(/ /g, "+");
  // .replace("bbbb", "/")
  // .replace("wwww", "=");

  console.log(originalKey, "090502024 dec rep 2");

  const decrypted2 = CryptoJS.AES.decrypt(
    `${originalKey}`,
    config?.portalSendIdKey
  );

  const decryptedData = decrypted2
    ? decrypted2.toString(CryptoJS.enc.Utf8)
    : null;

  if (decryptedData === null) {
    window.location.href = "/404";
    return;
  }
  if (!decryptedData) {
    window.location.href = "/404";
    return null;
  }

  const parseddata = JSON.parse(decryptedData);

  console.log(parseddata, "090502024 ID 3");
  if (parseddata?.status !== "ok") {
    window.location.href = "/404";
    return null;
  }
  console.log(parseddata?.ID, "090502024 ID 4");
  return parseddata?.ID;
}

// decrypt by alpha and numeric
export function decryptAndConvert(alphanumeric) {
  console.log(alphanumeric, "alphanumeric");

  const alphanumericValues =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = 0;

  for (let i = 0; i < alphanumeric.length; i++) {
    result = result * 3 + alphanumericValues.indexOf(alphanumeric.charAt(i));
  }

  // return result;
  console.log(result, "alphanumeric");
  let encryptedText = result.toString();

  let key = 4;
  let decryptedText = "";
  for (let i = 0; i < encryptedText.length; i++) {
    let charCode = encryptedText.charCodeAt(i);
    if (
      (charCode >= 65 && charCode <= 90) ||
      (charCode >= 97 && charCode <= 122)
    ) {
      // Uppercase and lowercase letters
      decryptedText += String.fromCharCode(
        ((charCode - 65 - key + 52) % 52) + 65
      );
    } else if (charCode >= 48 && charCode <= 57) {
      // Numeric characters
      decryptedText += String.fromCharCode(
        ((charCode - 48 - key + 10) % 10) + 48
      );
    } else {
      decryptedText += encryptedText.charAt(i);
    }
  }
  console.log(decryptedText, "alphanumeric");
  return decryptedText;
}
//encrypt by alpha and numeric
export function encryptAndConvert(textData) {
  let text = textData.toString();
  let key = 4;
  let encryptedText = "";
  for (let i = 0; i < text.length; i++) {
    let charCode = text.charCodeAt(i);
    if (
      (charCode >= 65 && charCode <= 90) ||
      (charCode >= 97 && charCode <= 122)
    ) {
      // Uppercase and lowercase letters
      encryptedText += String.fromCharCode(((charCode - 65 + key) % 52) + 65);
    } else if (charCode >= 48 && charCode <= 57) {
      // Numeric characters
      encryptedText += String.fromCharCode(((charCode - 48 + key) % 10) + 48);
    } else {
      encryptedText += text.charAt(i);
    }
  }

  // return encryptedText;
  let number = encryptedText;
  const alphanumericValues =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";

  while (number > 0) {
    let remainder = number % 3;
    result = alphanumericValues.charAt(remainder) + result;
    number = Math.floor(number / 3);
    console.log(number, "loopnumber");
  }
  console.log(result, "loopnumber result");
  return result;
}

export const clientId =
  "834409604454-6gs7ilj2545vbhfpmjjp3bfq5rnv8s8v.apps.googleusercontent.com";

// Handle the for the file change
export const CommonHandleFileChange = (
  event,
  index,
  setLoading,
  setAttachmentUrl
) => {
  setLoading(true);
  if (
    UploadFileVaidation(
      event.target.name,
      event?.currentTarget?.files[0],
      setLoading,
      setAttachmentUrl
    )
  ) {
    // console.log(event.currentTarget.files[0]);
    CommonUploadFileFun(
      event?.currentTarget?.files[0],
      event.target.name,
      index,
      setLoading,
      setAttachmentUrl
    );
  }

  // const files = event.target.files;
  // if (files) {
  //   let images = [];
  //   for (let i = 0; i < files.length; i++) {
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       images.push({
  //         name: files[i].name,
  //         preview: e.target.result,
  //       });
  //     };
  //     reader.readAsDataURL(files[i]);
  //   }
  // }
  setLoading(false);
};

// Validation for the file upload
export const UploadFileVaidation = (
  name,
  value,
  setLoading,
  setAttachmentUrl
) => {
  switch (name) {
    case "Attachment":
      if (!value.name.match(/\.(jpg|jpeg|png|pdf|heic)$/)) {
        setLoading(false);
        setAttachmentUrl(null);
        toastError("Please select a correct format for attachment");
        return false;
      } else {
        return true;
      }
    default: {
      return true;
    }
  }
};

// Upload function for uploading the file on AWS
export const CommonUploadFileFun = async (
  file,
  type,
  index,
  setLoading,
  setAttachmentUrl
) => {
  // setBtnFileLoader({ [type]: true });

  await uploadAWS(file, AWS_IMAGE_FOLDER_SALES, (data) => {
    if (data) {
      if (type === "Attachment") {
        // setFileUrl(data);
        setAttachmentUrl(data);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  });
};

export const handleSaveColumnOrder = (
  loginId,
  ModuleTableName,
  Data,
  token,
  columnVisibility
) => {
  const falseKeysString = Object.keys(columnVisibility)
    .filter((key) => columnVisibility[key] === false)
    .join(",");

  const submitData = {
    employeeId: loginId,
    ModuleTableName: ModuleTableName,
    Data: Data.join(","),
    columnVisibility: falseKeysString,
  };
  console.log(submitData, "checkemployeedata");
  // return
  axios
    .post(
      `${config.employeesBaseUrl}/employees/savecolumnorderbyemployee`,
      submitData,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      }
    )
    .then((response) => {
      if (response.data.ResponseCode === "SUCCESS") {
        toastSuccess("Column Order Save Successfully");
      } else {
        toastError(response.data.ResponseMessage);
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

export const changePriceFormat = (value) => {
  return Number(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const ExportExcel = (mainData = [], field = "AllData", from = "") => {

  console.log(mainData, field,from, "export in excel")
  const workbook = XLSX.utils.book_new();

  let Data = [];
  if (from == "DriverDailySheet" && field == "AllData") {
    Data = mainData.map((el,index) => {
      return{
        '#': index+1,
        'BOX': "",
        'INV': el.InvoiceNo,
        'Name': el.companyname,
        'Amount': `$${changePriceFormat(el?.Total)}`,
        'Previous':`$${changePriceFormat(el?.Balance)}`,
        'Cash': "",
        'Check': "",
        'Notes': "",
      }
    })
  }else if (from == "itemListExport" && field == "AllData") {
    Data = mainData.map((el, index) => {
      const newData = { ...el.original };
      if (!checkUserPermission("show-cost-price")) {
      delete newData.Costprice;
      }
      return newData;
    });
  } else {
    toastError("Please Pass Model");
    return;
  }

  // Convert the data to a worksheet
  const worksheet = XLSX.utils.json_to_sheet(Data);

  // Add the worksheet to the workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  // Save the workbook as an Excel file
  XLSX.writeFile(workbook, `${from}.xlsx`);
};


// Custom debounce helper
export const useDebounce = (value, delay) =>  {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect
  (() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}